// import React, { useState, useEffect } from "react";
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import TablePagination from "@mui/material/TablePagination";
// import Paper from "@mui/material/Paper";
// import Chip from "@mui/material/Chip";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
// import Divider from "@mui/material/Divider";
// import CircularProgress from "@mui/material/CircularProgress";
// import Alert from "@mui/material/Alert";
// import Container from "@mui/material/Container";

// // Material Dashboard 2 React components - removed MDBox and MDTypography

// // Material Dashboard 2 React example components
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";

// function CheckoutTables() {
//   const [checkouts, setCheckouts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [selectedCheckout, setSelectedCheckout] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);

//   // Fetch checkout data
//   useEffect(() => {
//     fetchCheckouts();
//   }, []);

//   const fetchCheckouts = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch("https://backend.jcgn.org/api/checkout/getAll");
//       const result = await response.json();

//       if (result.status) {
//         setCheckouts(result.data);
//       } else {
//         setError("Failed to fetch checkout data");
//       }
//     } catch (err) {
//       setError("Error fetching checkout data");
//       console.error("Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle pagination
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Handle row click
//   const handleRowClick = (checkout) => {
//     setSelectedCheckout(checkout);
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedCheckout(null);
//   };

//   // Get status chip color
//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case "pending":
//         return "warning";
//       case "completed":
//         return "success";
//       case "failed":
//         return "error";
//       case "cancelled":
//         return "default";
//       default:
//         return "default";
//     }
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   // Paginated data
//   const paginatedCheckouts = checkouts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

//   if (loading) {
//     return (
//       <DashboardLayout>
//         <DashboardNavbar />
//         <Container sx={{ pt: 6, pb: 3 }}>
//           <Box
//             display="flex"
//             justifyContent="center"
//             alignItems="center"
//             minHeight="400px"
//           >
//             <CircularProgress />
//           </Box>
//         </Container>
//         <Footer />
//       </DashboardLayout>
//     );
//   }

//   if (error) {
//     return (
//       <DashboardLayout>
//         <DashboardNavbar />
//         <Container sx={{ pt: 6, pb: 3 }}>
//           <Alert severity="error">{error}</Alert>
//         </Container>
//         <Footer />
//       </DashboardLayout>
//     );
//   }

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <Container sx={{ pt: 6, pb: 3 }}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               {/* Header Section */}
//               <Box
//                 sx={{
//                   mx: 2,
//                   mt: -3,
//                   py: 3,
//                   px: 2,
//                   background: 'linear-gradient(195deg, #49a3f1, #1A73E8)',
//                   borderRadius: 2,
//                   color: 'white',
//                   boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(26, 115, 232, 0.4)'
//                 }}
//               >
//                 <Typography variant="h6" color="white">
//                   Order Table ({checkouts.length} records)
//                 </Typography>
//               </Box>

//               {/* Table Section */}
//               <Box sx={{ pt: 3 }}>
//                 <TableContainer component={Paper} elevation={0}>
//                   <Table>
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>
//                           <Typography variant="subtitle2" fontWeight="bold">ID</Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="subtitle2" fontWeight="bold">User ID</Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="subtitle2" fontWeight="bold">Sub Total</Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="subtitle2" fontWeight="bold">Tax Charge</Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="subtitle2" fontWeight="bold">Net Total</Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="subtitle2" fontWeight="bold">Status</Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="subtitle2" fontWeight="bold">Payment</Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="subtitle2" fontWeight="bold">Created At</Typography>
//                         </TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {paginatedCheckouts.map((checkout) => (
//                         <TableRow
//                           key={checkout.id}
//                           hover
//                           onClick={() => handleRowClick(checkout)}
//                           sx={{ cursor: "pointer" }}
//                         >
//                           <TableCell>{checkout.id}</TableCell>
//                           <TableCell>{checkout.userId}</TableCell>
//                           <TableCell>${checkout.subTotal}</TableCell>
//                           <TableCell>${checkout.taxCharge}</TableCell>
//                           <TableCell>
//                             <Typography variant="body2" fontWeight="bold">
//                               ${checkout.netTotal}
//                             </Typography>
//                           </TableCell>
//                           <TableCell>
//                             <Chip
//                               label={checkout.status}
//                               color={getStatusColor(checkout.status)}
//                               size="small"
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <Chip
//                               label={checkout.is_payment_success ? "Success" : "Pending"}
//                               color={checkout.is_payment_success ? "success" : "warning"}
//                               size="small"
//                             />
//                           </TableCell>
//                           <TableCell>{formatDate(checkout.createdAt)}</TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                   <TablePagination
//                     rowsPerPageOptions={[5, 10, 25, 50]}
//                     component="div"
//                     count={checkouts.length}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     onPageChange={handleChangePage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                   />
//                 </TableContainer>
//               </Box>
//             </Card>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Checkout Details Dialog */}
//       <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Typography variant="h5" component="div">
//             Checkout Details - ID: {selectedCheckout?.id}
//           </Typography>
//         </DialogTitle>
//         <DialogContent>
//           {selectedCheckout && (
//             <Box>
//               <Grid container spacing={3}>
//                 {/* Basic Information */}
//                 <Grid item xs={12}>
//                   <Typography variant="h6" gutterBottom color="primary">
//                     Basic Information
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     User ID
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.userId}</Typography>
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Cart ID
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.cartId || "N/A"}</Typography>
//                 </Grid>

//                 {/* Financial Information */}
//                 <Grid item xs={12}>
//                   <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 2 }}>
//                     Financial Details
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                 </Grid>

//                 <Grid item xs={4}>
//                   <Typography variant="body2" color="textSecondary">
//                     Sub Total
//                   </Typography>
//                   <Typography variant="h6" color="success.main">
//                     ${selectedCheckout.subTotal}
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={4}>
//                   <Typography variant="body2" color="textSecondary">
//                     Tax Charge
//                   </Typography>
//                   <Typography variant="h6">${selectedCheckout.taxCharge}</Typography>
//                 </Grid>

//                 <Grid item xs={4}>
//                   <Typography variant="body2" color="textSecondary">
//                     Commission
//                   </Typography>
//                   <Typography variant="h6">${selectedCheckout.commission}</Typography>
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Typography variant="body2" color="textSecondary">
//                     Net Total
//                   </Typography>
//                   <Typography variant="h4" color="primary">
//                     ${selectedCheckout.netTotal}
//                   </Typography>
//                 </Grid>

//                 {/* Address Information */}
//                 <Grid item xs={12}>
//                   <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 2 }}>
//                     Address Information
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Contact Name
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.contactname || "N/A"}</Typography>
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Mobile Number
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.mobilenumber || "N/A"}</Typography>
//                 </Grid>

//                 <Grid item xs={4}>
//                   <Typography variant="body2" color="textSecondary">
//                     Country
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.country || "N/A"}</Typography>
//                 </Grid>

//                 <Grid item xs={4}>
//                   <Typography variant="body2" color="textSecondary">
//                     State
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.state || "N/A"}</Typography>
//                 </Grid>

//                 <Grid item xs={4}>
//                   <Typography variant="body2" color="textSecondary">
//                     City
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.city || "N/A"}</Typography>
//                 </Grid>

//                 <Grid item xs={8}>
//                   <Typography variant="body2" color="textSecondary">
//                     Address Line 1
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.line1 || "N/A"}</Typography>
//                 </Grid>

//                 <Grid item xs={4}>
//                   <Typography variant="body2" color="textSecondary">
//                     Zip Code
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.zipCode || "N/A"}</Typography>
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Typography variant="body2" color="textSecondary">
//                     Address Line 2
//                   </Typography>
//                   <Typography variant="body1">{selectedCheckout.line2 || "N/A"}</Typography>
//                 </Grid>

//                 {/* Status Information */}
//                 <Grid item xs={12}>
//                   <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 2 }}>
//                     Status Information
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                 </Grid>

//                 <Grid item xs={4}>
//                   <Typography variant="body2" color="textSecondary">
//                     Status
//                   </Typography>
//                   <Chip
//                     label={selectedCheckout.status}
//                     color={getStatusColor(selectedCheckout.status)}
//                   />
//                 </Grid>

//                 <Grid item xs={4}>
//                   <Typography variant="body2" color="textSecondary">
//                     Payment Status
//                   </Typography>
//                   <Chip
//                     label={selectedCheckout.is_payment_success ? "Success" : "Pending"}
//                     color={selectedCheckout.is_payment_success ? "success" : "warning"}
//                   />
//                 </Grid>

//                 {/* Timestamps */}
//                 <Grid item xs={12}>
//                   <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 2 }}>
//                     Timestamps
//                   </Typography>
//                   <Divider sx={{ mb: 2 }} />
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Created At
//                   </Typography>
//                   <Typography variant="body1">{formatDate(selectedCheckout.createdAt)}</Typography>
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Updated At
//                   </Typography>
//                   <Typography variant="body1">{formatDate(selectedCheckout.updatedAt)}</Typography>
//                 </Grid>
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialog} color="primary" variant="contained">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default CheckoutTables;

// ===============================================================


// ====================================================

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   TableSortLabel,
//   Toolbar,
//   Typography,
//   Checkbox,
//   IconButton,
//   Tooltip,
//   FormControlLabel,
//   Switch,
//   Chip,
//   Avatar,
//   Stack,
//   Card,
//   CardContent,
//   Button,
//   TextField,
//   InputAdornment,
//   Menu,
//   MenuItem,
//   ListItemIcon,
//   ListItemText,
//   Fade,
//   CircularProgress,
//   Alert,
//   Container,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Grid,
//   Divider,
// } from '@mui/material';
// import {
//   Delete as DeleteIcon,
//   FilterList as FilterListIcon,
//   Search as SearchIcon,
//   Visibility as VisibilityIcon,
//   Edit as EditIcon,
//   MoreVert as MoreVertIcon,
//   Download as DownloadIcon,
//   Refresh as RefreshIcon,
// } from '@mui/icons-material';
// import { alpha } from '@mui/material/styles';

// // Material Dashboard 2 React example components
// import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
// import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
// import Footer from 'examples/Footer';
// import {BASE_URL} from '../../api/axios';

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

// function getComparator(order, orderBy) {
//   return order === 'desc'
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

// function stableSort(array, comparator) {
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) {
//       return order;
//     }
//     return a[1] - b[1];
//   });
//   return stabilizedThis.map((el) => el[0]);
// }

// const headCells = [
//   {
//     id: 'id',
//     numeric: false,
//     disablePadding: false,
//     label: 'Order ID',
//     width: '120px',
//   },
//   {
//     id: 'userId',
//     numeric: false,
//     disablePadding: false,
//     label: 'Customer',
//     width: '120px',
//   },
//   {
//     id: 'subTotal',
//     numeric: true,
//     disablePadding: false,
//     label: 'Subtotal',
//     width: '120px',
//   },
//   {
//     id: 'taxCharge',
//     numeric: true,
//     disablePadding: false,
//     label: 'Tax',
//     width: '100px',
//   },
//   {
//     id: 'netTotal',
//     numeric: true,
//     disablePadding: false,
//     label: 'Total Amount',
//     width: '140px',
//   },
//   {
//     id: 'status',
//     numeric: false,
//     disablePadding: false,
//     label: 'Status',
//     width: '120px',
//   },
//   {
//     id: 'is_payment_success',
//     numeric: false,
//     disablePadding: false,
//     label: 'Payment',
//     width: '120px',
//   },
//   {
//     id: 'createdAt',
//     numeric: false,
//     disablePadding: false,
//     label: 'Order Date',
//     width: '180px',
//   },
// ];

// function EnhancedTableHead(props) {
//   const {
//     onSelectAllClick,
//     order,
//     orderBy,
//     numSelected,
//     rowCount,
//     onRequestSort,
//   } = props;
//   const createSortHandler = (property) => (event) => {
//     onRequestSort(event, property);
//   };

//   return (
//     <TableHead>
//       <TableRow>
//         <TableCell 
//           padding="checkbox" 
//           sx={{ 
//             width: '48px', 
//             minWidth: '48px', 
//             maxWidth: '48px',
//             backgroundColor: '#f8f9fa' 
//           }}
//         >
//           <Checkbox
//             color="primary"
//             indeterminate={numSelected > 0 && numSelected < rowCount}
//             checked={rowCount > 0 && numSelected === rowCount}
//             onChange={onSelectAllClick}
//             inputProps={{
//               'aria-label': 'select all orders',
//             }}
//           />
//         </TableCell>
//         {headCells.map((headCell) => (
//           <TableCell
//             key={headCell.id}
//             align={headCell.numeric ? 'right' : 'left'}
//             padding={headCell.disablePadding ? 'none' : 'normal'}
//             sortDirection={orderBy === headCell.id ? order : false}
//             sx={{ 
//               fontWeight: 'bold', 
//               backgroundColor: '#f8f9fa',
//               width: headCell.width,
//               minWidth: headCell.width,
//             }}
//           >
//             <TableSortLabel
//               active={orderBy === headCell.id}
//               direction={orderBy === headCell.id ? order : 'asc'}
//               onClick={createSortHandler(headCell.id)}
//             >
//               {headCell.label}
//             </TableSortLabel>
//           </TableCell>
//         ))}
//         <TableCell
//           align="center"
//           sx={{ 
//             fontWeight: 'bold', 
//             backgroundColor: '#f8f9fa',
//             width: '100px',
//             minWidth: '100px',
//           }}
//         >
//           Actions
//         </TableCell>
//       </TableRow>
//     </TableHead>
//   );
// }

// function EnhancedTableToolbar(props) {
//   const { numSelected, searchTerm, onSearchChange, onRefresh, onDelete } =
//     props;

//   return (
//     <Toolbar
//       sx={{
//         pl: { sm: 2 },
//         pr: { xs: 1, sm: 1 },
//         ...(numSelected > 0 && {
//           bgcolor: (theme) =>
//             alpha(
//               theme.palette.primary.main,
//               theme.palette.action.activatedOpacity
//             ),
//         }),
//       }}
//     >
//       {numSelected > 0 ? (
//         <Typography
//           sx={{ flex: '1 1 100%' }}
//           color="inherit"
//           variant="subtitle1"
//           component="div"
//         >
//           {numSelected} selected
//         </Typography>
//       ) : (
//         <Box sx={{ display: 'flex', alignItems: 'center', flex: '1 1 100%' }}>
//           <Typography
//             sx={{ flex: '1 1 100%' }}
//             variant="h6"
//             id="tableTitle"
//             component="div"
//           >
//             Orders Management
//           </Typography>
//           <TextField
//             size="small"
//             placeholder="Search orders..."
//             value={searchTerm}
//             onChange={onSearchChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon />
//                 </InputAdornment>
//               ),
//             }}
//             sx={{ minWidth: 250, mr: 2 }}
//           />
//         </Box>
//       )}

//       {numSelected > 0 ? (
//         <Tooltip title="Delete selected">
//           <IconButton onClick={onDelete}>
//             <DeleteIcon />
//           </IconButton>
//         </Tooltip>
//       ) : (
//         <Stack direction="row" spacing={1}>
//           <Tooltip title="Refresh data">
//             <IconButton onClick={onRefresh}>
//               <RefreshIcon />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Filter list">
//             <IconButton>
//               <FilterListIcon />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Export data">
//             <IconButton>
//               <DownloadIcon />
//             </IconButton>
//           </Tooltip>
//         </Stack>
//       )}
//     </Toolbar>
//   );
// }

// function CheckoutTables() {
//   const [checkouts, setCheckouts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [order, setOrder] = useState('desc');
//   const [orderBy, setOrderBy] = useState('createdAt');
//   const [selected, setSelected] = useState([]);
//   const [page, setPage] = useState(0);
//   const [dense, setDense] = useState(false);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedCheckout, setSelectedCheckout] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [selectedRowId, setSelectedRowId] = useState(null);

//   // Fetch checkout data
//   useEffect(() => {
//     fetchCheckouts();
//   }, []);

//   const fetchCheckouts = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
      
//       if (!token) {
//         setError('No authentication token found');
//         return;
//       }

//       const response = await fetch(`${BASE_URL}api/checkout/getCheckouts/byAssignee`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       const result = await response.json();

//       if (result.status) {
//         // Filter only orders with status 'Shipped'
//         const shippedOrders = result.data.filter(order => 
//           order.status && order.status.toLowerCase() === 'shipped'
//         );
//         setCheckouts(shippedOrders);
//       } else {
//         setError('Failed to fetch checkout data');
//       }
//     } catch (err) {
//       setError('Error fetching checkout data');
//       console.error('Error:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleRequestSort = (event, property) => {
//     const isAsc = orderBy === property && order === 'asc';
//     setOrder(isAsc ? 'desc' : 'asc');
//     setOrderBy(property);
//   };

//   const handleSelectAllClick = (event) => {
//     if (event.target.checked) {
//       const newSelected = filteredCheckouts.map((n) => n.id);
//       setSelected(newSelected);
//       return;
//     }
//     setSelected([]);
//   };

//   const handleClick = (event, id) => {
//     const selectedIndex = selected.indexOf(id);
//     let newSelected = [];

//     if (selectedIndex === -1) {
//       newSelected = newSelected.concat(selected, id);
//     } else if (selectedIndex === 0) {
//       newSelected = newSelected.concat(selected.slice(1));
//     } else if (selectedIndex === selected.length - 1) {
//       newSelected = newSelected.concat(selected.slice(0, -1));
//     } else if (selectedIndex > 0) {
//       newSelected = newSelected.concat(
//         selected.slice(0, selectedIndex),
//         selected.slice(selectedIndex + 1)
//       );
//     }
//     setSelected(newSelected);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleChangeDense = (event) => {
//     setDense(event.target.checked);
//   };

//   const handleSearchChange = (event) => {
//     setSearchTerm(event.target.value);
//     setPage(0);
//   };

//   const handleViewDetails = (checkout) => {
//     setSelectedCheckout(checkout);
//     setOpenDialog(true);
//     setAnchorEl(null);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedCheckout(null);
//   };

//   const handleMenuClick = (event, id) => {
//     setAnchorEl(event.currentTarget);
//     setSelectedRowId(id);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setSelectedRowId(null);
//   };

//   const handleDeleteSelected = () => {
//     console.log('Delete selected:', selected);
//     // Implement delete functionality
//     setSelected([]);
//   };

//   const isSelected = (id) => selected.indexOf(id) !== -1;

//   // Filter checkouts based on search term
//   const filteredCheckouts = checkouts.filter(
//     (checkout) =>
//       checkout.id.toString().includes(searchTerm) ||
//       checkout.userId.toString().includes(searchTerm) ||
//       checkout.status.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Get status chip color
//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'pending':
//         return 'warning';
//       case 'completed':
//         return 'success';
//       case 'shipped':
//         return 'info';
//       case 'failed':
//         return 'error';
//       case 'cancelled':
//         return 'default';
//       default:
//         return 'default';
//     }
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD',
//     }).format(amount);
//   };

//   const visibleRows = React.useMemo(
//     () =>
//       stableSort(filteredCheckouts, getComparator(order, orderBy)).slice(
//         page * rowsPerPage,
//         page * rowsPerPage + rowsPerPage
//       ),
//     [order, orderBy, page, rowsPerPage, filteredCheckouts]
//   );

//   if (loading) {
//     return (
//       <DashboardLayout>
//         <DashboardNavbar />
//         <Container sx={{ pt: 6, pb: 3 }}>
//           <Box
//             display="flex"
//             justifyContent="center"
//             alignItems="center"
//             minHeight="400px"
//           >
//             <CircularProgress size={60} />
//           </Box>
//         </Container>
//         <Footer />
//       </DashboardLayout>
//     );
//   }

//   if (error) {
//     return (
//       <DashboardLayout>
//         <DashboardNavbar />
//         <Container sx={{ pt: 6, pb: 3 }}>
//           <Alert severity="error" sx={{ mb: 3 }}>
//             {error}
//           </Alert>
//         </Container>
//         <Footer />
//       </DashboardLayout>
//     );
//   }

//   if (checkouts.length === 0) {
//     return (
//       <DashboardLayout>
//         <DashboardNavbar />
//         <Container sx={{ pt: 6, pb: 3 }}>
//           <Alert severity="info" sx={{ mb: 3 }}>
//             No shipped orders found for this assignee.
//           </Alert>
//         </Container>
//         <Footer />
//       </DashboardLayout>
//     );
//   }

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <Container sx={{ pt: 6, pb: 3 }}>
//         <Card elevation={3}>
//           <CardContent>
//             <Box sx={{ width: '100%' }}>
//               <Paper sx={{ width: '100%', mb: 2 }}>
//                 <EnhancedTableToolbar
//                   numSelected={selected.length}
//                   searchTerm={searchTerm}
//                   onSearchChange={handleSearchChange}
//                   onRefresh={fetchCheckouts}
//                   onDelete={handleDeleteSelected}
//                 />
//                 <TableContainer>
//                   <Table
//                     sx={{ minWidth: 750 }}
//                     aria-labelledby="tableTitle"
//                     size={dense ? 'small' : 'medium'}
//                   >
//                     <EnhancedTableHead
//                       numSelected={selected.length}
//                       order={order}
//                       orderBy={orderBy}
//                       onSelectAllClick={handleSelectAllClick}
//                       onRequestSort={handleRequestSort}
//                       rowCount={filteredCheckouts.length}
//                     />
//                     <TableBody>
//                       {visibleRows.map((row, index) => {
//                         const isItemSelected = isSelected(row.id);
//                         const labelId = `enhanced-table-checkbox-${index}`;

//                         return (
//                           <TableRow
//                             hover
//                             role="checkbox"
//                             aria-checked={isItemSelected}
//                             tabIndex={-1}
//                             key={row.id}
//                             selected={isItemSelected}
//                             sx={{
//                               cursor: 'pointer',
//                               '&:hover': {
//                                 backgroundColor: alpha('#1976d2', 0.04),
//                               },
//                             }}
//                           >
//                             <TableCell 
//                               padding="checkbox"
//                               sx={{ 
//                                 width: '120px', 

//                               }}
//                             >
//                               <Checkbox
//                                 onClick={(event) => handleClick(event, row.id)}
//                                 color="primary"
//                                 checked={isItemSelected}
//                                 inputProps={{
//                                   'aria-labelledby': labelId,
//                                 }}
//                               />
//                             </TableCell>
//                             <TableCell sx={{ width: '120px' }}>
//                               <Box
//                                 sx={{
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                 }}
//                               >
//                                 <Typography variant="body2" fontWeight="medium">
//                                   {row.id}
//                                 </Typography>
//                               </Box>
//                             </TableCell>
//                             <TableCell sx={{ width: '120px' }}>
//                               <Typography variant="body2" fontWeight="medium">
//                                 {row.userId}
//                               </Typography>
//                             </TableCell>
//                             <TableCell align="right" sx={{ width: '120px' }}>
//                               <Typography
//                                 variant="body2"
//                                 color="text.secondary"
//                               >
//                                 {formatCurrency(row.subTotal)}
//                               </Typography>
//                             </TableCell>
//                             <TableCell align="right" sx={{ width: '100px' }}>
//                               <Typography
//                                 variant="body2"
//                                 color="text.secondary"
//                               >
//                                 {formatCurrency(row.taxCharge)}
//                               </Typography>
//                             </TableCell>
//                             <TableCell align="right" sx={{ width: '140px' }}>
//                               <Typography
//                                 variant="body1"
//                                 color="primary"
//                                 fontWeight="bold"
//                               >
//                                 {formatCurrency(row.netTotal)}
//                               </Typography>
//                             </TableCell>
//                             <TableCell sx={{ width: '120px' }}>
//                               <Chip
//                                 label={row.status}
//                                 color={getStatusColor(row.status)}
//                                 size="small"
//                                 sx={{ fontWeight: 'medium' }}
//                               />
//                             </TableCell>
//                             <TableCell sx={{ width: '120px' }}>
//                               <Chip
//                                 label={
//                                   row.is_payment_success ? 'Paid' : 'Pending'
//                                 }
//                                 color={
//                                   row.is_payment_success ? 'success' : 'warning'
//                                 }
//                                 size="small"
//                                 variant={
//                                   row.is_payment_success ? 'filled' : 'outlined'
//                                 }
//                                 sx={{ fontWeight: 'medium' }}
//                               />
//                             </TableCell>
//                             <TableCell sx={{ width: '180px' }}>
//                               <Typography variant="body2">
//                                 {formatDate(row.createdAt)}
//                               </Typography>
//                             </TableCell>
//                             <TableCell 
//                               align="center" 
//                               sx={{ 
//                                 width: '100px',
//                                 minWidth: '100px',
//                               }}
//                             >
//                               <IconButton
//                                 size="small"
//                                 onClick={(event) =>
//                                   handleMenuClick(event, row.id)
//                                 }
//                               >
//                                 <MoreVertIcon />
//                               </IconButton>
//                             </TableCell>
//                           </TableRow>
//                         );
//                       })}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//                 <TablePagination
//                   rowsPerPageOptions={[5, 10, 25, 50]}
//                   component="div"
//                   count={filteredCheckouts.length}
//                   rowsPerPage={rowsPerPage}
//                   page={page}
//                   onPageChange={handleChangePage}
//                   onRowsPerPageChange={handleChangeRowsPerPage}
//                 />
//               </Paper>
//               <FormControlLabel
//                 control={
//                   <Switch checked={dense} onChange={handleChangeDense} />
//                 }
//                 label="Dense padding"
//               />
//             </Box>
//           </CardContent>
//         </Card>

//         {/* Action Menu */}
//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleMenuClose}
//           TransitionComponent={Fade}
//         >
//           <MenuItem
//             onClick={() => {
//               const checkout = checkouts.find((c) => c.id === selectedRowId);
//               handleViewDetails(checkout);
//             }}
//           >
//             <ListItemIcon>
//               <VisibilityIcon fontSize="small" />
//             </ListItemIcon>
//             <ListItemText>View Details</ListItemText>
//           </MenuItem>
//           <MenuItem onClick={handleMenuClose}>
//             <ListItemIcon>
//               <EditIcon fontSize="small" />
//             </ListItemIcon>
//             <ListItemText>Edit Order</ListItemText>
//           </MenuItem>
//           <MenuItem onClick={handleMenuClose}>
//             <ListItemIcon>
//               <DeleteIcon fontSize="small" />
//             </ListItemIcon>
//             <ListItemText>Delete</ListItemText>
//           </MenuItem>
//         </Menu>

//         {/* Order Details Dialog */}
//         <Dialog
//           open={openDialog}
//           onClose={handleCloseDialog}
//           maxWidth="md"
//           fullWidth
//         >
//           <DialogTitle>
//             <Typography variant="h5" component="div">
//               Order Details - #{selectedCheckout?.id}
//             </Typography>
//           </DialogTitle>
//           <DialogContent>
//             {selectedCheckout && (
//               <Box>
//                 <Grid container spacing={3}>
//                   {/* Basic Information */}
//                   <Grid item xs={12}>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Basic Information
//                     </Typography>
//                     <Divider sx={{ mb: 2 }} />
//                   </Grid>

//                   <Grid item xs={6}>
//                     <Typography variant="body2" color="textSecondary">
//                       Customer ID
//                     </Typography>
//                     <Typography variant="body1" fontWeight="medium">
//                       #{selectedCheckout.userId}
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={6}>
//                     <Typography variant="body2" color="textSecondary">
//                       Cart ID
//                     </Typography>
//                     <Typography variant="body1" fontWeight="medium">
//                       {selectedCheckout.cartId || 'N/A'}
//                     </Typography>
//                   </Grid>

//                   {/* Shipping Details */}
//                   <Grid item xs={12}>
//                     <Typography
//                       variant="h6"
//                       gutterBottom
//                       color="primary"
//                       sx={{ mt: 2 }}
//                     >
//                       Shipping Details
//                     </Typography>
//                     <Divider sx={{ mb: 2 }} />
//                   </Grid>

//                   <Grid item xs={4}>
//                     <Typography variant="body2" color="textSecondary">
//                       Subtotal
//                     </Typography>
//                     <Typography variant="h6" color="success.main">
//                       {formatCurrency(selectedCheckout.subTotal)}
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={4}>
//                     <Typography variant="body2" color="textSecondary">
//                       Tax Amount
//                     </Typography>
//                     <Typography variant="h6">
//                       {formatCurrency(selectedCheckout.taxCharge)}
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={4}>
//                     <Typography variant="body2" color="textSecondary">
//                       Commission
//                     </Typography>
//                     <Typography variant="h6">
//                       {formatCurrency(selectedCheckout.commission || 0)}
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Typography variant="body2" color="textSecondary">
//                       Total Amount
//                     </Typography>
//                     <Typography variant="h4" color="primary" fontWeight="bold">
//                       {formatCurrency(selectedCheckout.netTotal)}
//                     </Typography>
//                   </Grid>

//                   {/* Financial Information */}
//                   <Grid item xs={12}>
//                     <Typography
//                       variant="h6"
//                       gutterBottom
//                       color="primary"
//                       sx={{ mt: 2 }}
//                     >
//                       Financial Details
//                     </Typography>
//                     <Divider sx={{ mb: 2 }} />
//                   </Grid>

//                   <Grid item xs={4}>
//                     <Typography variant="body2" color="textSecondary">
//                       Subtotal
//                     </Typography>
//                     <Typography variant="h6" color="success.main">
//                       {formatCurrency(selectedCheckout.subTotal)}
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={4}>
//                     <Typography variant="body2" color="textSecondary">
//                       Tax Amount
//                     </Typography>
//                     <Typography variant="h6">
//                       {formatCurrency(selectedCheckout.taxCharge)}
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={4}>
//                     <Typography variant="body2" color="textSecondary">
//                       Commission
//                     </Typography>
//                     <Typography variant="h6">
//                       {formatCurrency(selectedCheckout.commission || 0)}
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Typography variant="body2" color="textSecondary">
//                       Total Amount
//                     </Typography>
//                     <Typography variant="h4" color="primary" fontWeight="bold">
//                       {formatCurrency(selectedCheckout.netTotal)}
//                     </Typography>
//                   </Grid>

//                   {/* Status Information */}
//                   <Grid item xs={12}>
//                     <Typography
//                       variant="h6"
//                       gutterBottom
//                       color="primary"
//                       sx={{ mt: 2 }}
//                     >
//                       Status Information
//                     </Typography>
//                     <Divider sx={{ mb: 2 }} />
//                   </Grid>

//                   <Grid item xs={6}>
//                     <Typography variant="body2" color="textSecondary">
//                       Order Status
//                     </Typography>
//                     <Chip
//                       label={selectedCheckout.status}
//                       color={getStatusColor(selectedCheckout.status)}
//                       sx={{ mt: 1 }}
//                     />
//                   </Grid>

//                   <Grid item xs={6}>
//                     <Typography variant="body2" color="textSecondary">
//                       Payment Status
//                     </Typography>
//                     <Chip
//                       label={
//                         selectedCheckout.is_payment_success
//                           ? 'Payment Successful'
//                           : 'Payment Pending'
//                       }
//                       color={
//                         selectedCheckout.is_payment_success
//                           ? 'success'
//                           : 'warning'
//                       }
//                       sx={{ mt: 1 }}
//                     />
//                   </Grid>

//                   {/* Timestamps */}
//                   <Grid item xs={12}>
//                     <Typography
//                       variant="h6"
//                       gutterBottom
//                       color="primary"
//                       sx={{ mt: 2 }}
//                     >
//                       Timeline
//                     </Typography>
//                     <Divider sx={{ mb: 2 }} />
//                   </Grid>

//                   <Grid item xs={6}>
//                     <Typography variant="body2" color="textSecondary">
//                       Order Created
//                     </Typography>
//                     <Typography variant="body1" fontWeight="medium">
//                       {formatDate(selectedCheckout.createdAt)}
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={6}>
//                     <Typography variant="body2" color="textSecondary">
//                       Last Updated
//                     </Typography>
//                     <Typography variant="body1" fontWeight="medium">
//                       {formatDate(selectedCheckout.updatedAt)}
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button
//               onClick={handleCloseDialog}
//               color="primary"
//               variant="contained"
//             >
//               Close
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Container>
//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default CheckoutTables;


// ==========================

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
// import { useState, useEffect } from "react";
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";

// // Material Dashboard 2 React components
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";

// // Material Dashboard 2 React example components
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
// import DataTable from "examples/Tables/DataTable";

// // Data
// import projectsTableData from "layouts/tables/data/projectsTableData";
// import { BASE_URL } from "../../api/axios";

// function Tables() {
//   const [checkoutData, setCheckoutData] = useState({ columns: [], rows: [] });
//   const [loading, setLoading] = useState(true);
//   const { columns: pColumns, rows: pRows } = projectsTableData();

//   // Fetch checkout data
//   useEffect(() => {
//     fetchCheckoutData();
//   }, []);

//   const fetchCheckoutData = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
      
//       if (!token) {
//         console.error('No authentication token found');
//         return;
//       }

//       const response = await fetch(`${BASE_URL}api/checkout/getCheckouts/byAssignee`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       const result = await response.json();

//       if (result.status) {
//         // Filter only orders with status 'Shipped'
//         const shippedOrders = result.data.filter(order => 
//           order.status && order.status.toLowerCase() === 'shipped'
//         );
        
//         // Transform data for DataTable
//         const transformedData = transformCheckoutData(shippedOrders);
//         setCheckoutData(transformedData);
//       } else {
//         console.error('Failed to fetch checkout data');
//       }
//     } catch (err) {
//       console.error('Error fetching checkout data:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const transformCheckoutData = (data) => {
//     // Define columns for DataTable
//     const columns = [
//       { Header: "Order ID", accessor: "orderId", width: "12%" },
//       { Header: "Customer", accessor: "customer", width: "12%" },
//       { Header: "Subtotal", accessor: "subtotal", width: "12%" },
//       { Header: "Tax", accessor: "tax", width: "10%" },
//       { Header: "Total Amount", accessor: "totalAmount", width: "14%" },
//       { Header: "Status", accessor: "status", width: "12%" },
//       { Header: "Payment", accessor: "payment", width: "12%" },
//       { Header: "Order Date", accessor: "orderDate", width: "16%" },
//     ];

//     // Transform rows for DataTable
//     const rows = data.map((checkout) => ({
//       orderId: (
//         <MDTypography variant="caption" color="text" fontWeight="medium">
//           #{checkout.id}
//         </MDTypography>
//       ),
//       customer: (
//         <MDTypography variant="caption" color="text" fontWeight="medium">
//           {checkout.userId}
//         </MDTypography>
//       ),
//       subtotal: (
//         <MDTypography variant="caption" color="text" fontWeight="medium">
//           {formatCurrency(checkout.subTotal)}
//         </MDTypography>
//       ),
//       tax: (
//         <MDTypography variant="caption" color="text" fontWeight="medium">
//           {formatCurrency(checkout.taxCharge)}
//         </MDTypography>
//       ),
//       totalAmount: (
//         <MDTypography variant="caption" color="success" fontWeight="bold">
//           {formatCurrency(checkout.netTotal)}
//         </MDTypography>
//       ),
//       status: (
//         <MDBox ml={-1}>
//           <MDTypography
//             variant="caption"
//             fontWeight="medium"
//             color={getStatusColor(checkout.status)}
//           >
//             {checkout.status}
//           </MDTypography>
//         </MDBox>
//       ),
//       payment: (
//         <MDTypography
//           variant="caption"
//           fontWeight="medium"
//           color={checkout.is_payment_success ? "success" : "warning"}
//         >
//           {checkout.is_payment_success ? "Paid" : "Pending"}
//         </MDTypography>
//       ),
//       orderDate: (
//         <MDTypography variant="caption" color="text" fontWeight="medium">
//           {formatDate(checkout.createdAt)}
//         </MDTypography>
//       ),
//     }));

//     return { columns, rows };
//   };

//   // Helper functions
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD',
//     }).format(amount);
//   };

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'pending':
//         return 'warning';
//       case 'completed':
//         return 'success';
//       case 'shipped':
//         return 'info';
//       case 'failed':
//         return 'error';
//       case 'cancelled':
//         return 'dark';
//       default:
//         return 'text';
//     }
//   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox
//                 mx={2}
//                 mt={-3}
//                 py={3}
//                 px={2}
//                 variant="gradient"
//                 bgColor="info"
//                 borderRadius="lg"
//                 coloredShadow="info"
//               >
//                 <MDTypography variant="h6" color="white">
//                   Checkout Orders Table
//                 </MDTypography>
//               </MDBox>
//               <MDBox pt={3}>
//                 {loading ? (
//                   <MDBox p={3} textAlign="center">
//                     <MDTypography variant="body2">Loading checkout data...</MDTypography>
//                   </MDBox>
//                 ) : checkoutData.rows.length > 0 ? (
//                   <DataTable
//                     table={checkoutData}
//                     isSorted={true}
//                     entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20, 25] }}
//                     showTotalEntries={true}
//                     noEndBorder
//                     canSearch={true}
//                   />
//                 ) : (
//                   <MDBox p={3} textAlign="center">
//                     <MDTypography variant="body2">No shipped orders found.</MDTypography>
//                   </MDBox>
//                 )}
//               </MDBox>
//             </Card>
//           </Grid>
//           {/* <Grid item xs={12}>
//             <Card>
//               <MDBox
//                 mx={2}
//                 mt={-3}
//                 py={3}
//                 px={2}
//                 variant="gradient"
//                 bgColor="info"
//                 borderRadius="lg"
//                 coloredShadow="info"
//               >
//                 <MDTypography variant="h6" color="white">
//                   Projects Table
//                 </MDTypography>
//               </MDBox>
//               <MDBox pt={3}>
//                 <DataTable
//                   table={{ columns: pColumns, rows: pRows }}
//                   isSorted={false}
//                   entriesPerPage={false}
//                   showTotalEntries={false}
//                   noEndBorder
//                 />
//               </MDBox>
//             </Card>
//           </Grid> */}
//         </Grid>
//       </MDBox>
//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default Tables;
// ==========================================================
import { useState, useEffect, useCallback } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { GOOGLE_MAPS_API_KEY } from "config/maps";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { BASE_URL } from "../../api/axios";

// A driver's jobs come from /api/orders/driver: one job per seller's part of
// an order. The driver accepts it, collects it from that seller, and
// confirms delivery with the customer's code for that part.

const api = async (path, options = {}) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
    },
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok || json.status === false) throw new Error(json.message || `Request failed (${response.status})`);
  return json;
};

// Phone photos are several MB: send a smaller copy that is still readable.
const shrinkPhoto = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      const scale = Math.min(1, 1280 / Math.max(image.width, image.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(image.width * scale);
      canvas.height = Math.round(image.height * scale);
      canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("Could not read the photo"))), "image/jpeg", 0.7);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not read the photo"));
    };
    image.src = url;
  });

const ACTIVE = ["Processing", "Shipped"];
const VEHICLE_LABEL = {
  bicycle: "Bicycle",
  motorcycle: "Motorcycle",
  car: "Car Sedan / SUV",
  three_wheeler: "Three-Wheeler",
  small_pickup: "Small Pickup Truck",
  cargo_van: "Pickup Truck / Cargo Van",
};
const whatsappLink = (phone) => `https://wa.me/${String(phone || "").replace(/[^\d]/g, "")}`;
const DRIVER_STATUS = { assigned: "New", accepted: "Accepted", declined: "Declined" };

const formatDate = (value) =>
  value
    ? new Date(value).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })
    : "";

const addressOf = (s = {}) =>
  [s.line1, s.line2, s.city, s.state, s.zipCode, s.country].filter(Boolean).join(", ");

const statusColor = (job) => {
  if (job.driverStatus === "assigned") return "warning";
  if (job.status === "Shipped") return "info";
  if (job.status === "Delivered") return "success";
  return "text";
};

function Tables() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showDone, setShowDone] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState(null);
  const [askLocation, setAskLocation] = useState(false);
  const [idPhoto, setIdPhoto] = useState(null);
  const [idPhotoUrl, setIdPhotoUrl] = useState("");

  const apiKey = GOOGLE_MAPS_API_KEY;

  const fetchJobs = useCallback(async () => {
    try {
      const json = await api("api/orders/driver");
      setJobs(json.jobs || []);
      setError("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  const selected = jobs.find((j) => j.id === selectedId) || null;

  // An ID photo belongs to one job: never carry it over to the next
  useEffect(() => {
    setCode("");
    setIdPhoto(null);
    setAskLocation(false);
  }, [selectedId]);

  useEffect(() => {
    if (!idPhoto) {
      setIdPhotoUrl("");
      return undefined;
    }
    const url = URL.createObjectURL(idPhoto);
    setIdPhotoUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [idPhoto]);

  const act = async (fn, success) => {
    setBusy(true);
    setNotice(null);
    try {
      const json = await fn();
      setNotice({ severity: "success", text: json?.message || success });
      await fetchJobs();
    } catch (err) {
      setNotice({ severity: "error", text: err.message });
    } finally {
      setBusy(false);
    }
  };

  const respond = (accept) =>
    act(
      () => api(`api/orders/parts/${selected.id}/respond`, { method: "POST", body: JSON.stringify({ accept }) }),
      accept ? "Job accepted" : "Job declined"
    );
  const answerLocation = (canLocateAddresses) => {
    setAskLocation(false);
    act(
      () =>
        api(`api/orders/parts/${selected.id}/respond`, {
          method: "POST",
          body: JSON.stringify({ accept: true, canLocateAddresses }),
        }),
      "Job accepted"
    );
  };
  const pickedUp = () =>
    act(
      () => api(`api/orders/parts/${selected.id}/picked-up`, { method: "POST" }),
      "Marked as picked up. The customer has their delivery code."
    );
  const confirm = () =>
    act(async () => {
      const body = new FormData();
      body.append("code", code.trim());
      body.append("idPhoto", idPhoto, "id.jpg");
      const json = await api(`api/orders/parts/${selected.id}/confirm-delivery`, {
        method: "POST",
        body,
      });
      setCode("");
      setIdPhoto(null);
      return json;
    }, "Delivery confirmed");
  const pickIdPhoto = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    try {
      setIdPhoto(await shrinkPhoto(file));
    } catch (err) {
      setNotice({ severity: "error", text: err.message });
    }
  };
  const resend = () =>
    act(() => api(`api/orders/parts/${selected.id}/resend-code`, { method: "POST" }), "Code sent to the customer");

  const visible = jobs.filter((j) => j.driverStatus !== "declined" && (showDone || ACTIVE.includes(j.status)));

  const table = {
    columns: [
      { Header: "Order", accessor: "orderId", width: "10%" },
      { Header: "Pick up from", accessor: "seller", width: "18%" },
      { Header: "Deliver to", accessor: "customer", width: "24%" },
      { Header: "Items", accessor: "items", width: "8%" },
      { Header: "Status", accessor: "status", width: "14%" },
      { Header: "Assigned", accessor: "date", width: "16%" },
      { Header: "", accessor: "actions", width: "6%", disableSortBy: true },
    ],
    rows: visible.map((job) => ({
      orderId: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          #{job.order.id}
        </MDTypography>
      ),
      seller: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {job.seller?.name || "Seller"}
        </MDTypography>
      ),
      customer: (
        <MDTypography variant="caption" color="text">
          {job.order.shipping?.contactName || job.order.buyer?.name || ""}
          {job.order.shipping?.city ? `, ${job.order.shipping.city}` : ""}
        </MDTypography>
      ),
      items: (
        <MDTypography variant="caption" color="text">
          {job.items.reduce((sum, i) => sum + i.quantity, 0)}
        </MDTypography>
      ),
      status: (
        <MDTypography variant="caption" fontWeight="medium" color={statusColor(job)}>
          {job.driverStatus === "assigned" ? "New job" : job.status === "Processing" ? "To collect" : job.status}
        </MDTypography>
      ),
      date: (
        <MDTypography variant="caption" color="text">
          {formatDate(job.order.paidAt || job.order.createdAt)}
        </MDTypography>
      ),
      actions: (
        <Tooltip title="Open job">
          <IconButton size="small" color="info" onClick={() => { setSelectedId(job.id); setNotice(null); setCode(""); }} aria-label={`Open order ${job.order.id}`}>
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    })),
  };

  const newJobs = jobs.filter((j) => j.driverStatus === "assigned" && ACTIVE.includes(j.status)).length;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info"
                display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
                <MDTypography variant="h6" color="white">
                  My Deliveries {newJobs ? `· ${newJobs} new` : ""}
                </MDTypography>
                <Button size="small" variant="outlined" sx={{ color: "#fff", borderColor: "rgba(255,255,255,.7)" }} onClick={() => setShowDone((v) => !v)}>
                  {showDone ? "Hide finished" : "Show finished"}
                </Button>
              </MDBox>
              <MDBox pt={3}>
                {notice && !selected && (
                  <MDBox px={3} pb={2}>
                    <Alert severity={notice.severity}>{notice.text}</Alert>
                  </MDBox>
                )}
                {loading ? (
                  <MDBox p={3} textAlign="center">
                    <MDTypography variant="body2">Loading your deliveries...</MDTypography>
                  </MDBox>
                ) : error ? (
                  <MDBox p={3}>
                    <Alert severity="error">{error}</Alert>
                  </MDBox>
                ) : table.rows.length > 0 ? (
                  <DataTable table={table} isSorted entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20, 25] }} showTotalEntries noEndBorder canSearch />
                ) : (
                  <MDBox p={3} textAlign="center">
                    <MDTypography variant="body2">No deliveries waiting for you.</MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <Dialog open={Boolean(selected)} onClose={() => setSelectedId(null)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Order #{selected?.order.id} · {selected?.seller?.name}
          <IconButton aria-label="close" onClick={() => setSelectedId(null)} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selected && (
            <Stack spacing={2}>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                <Chip size="small" label={selected.status} color={selected.status === "Delivered" ? "success" : "info"} />
                <Chip size="small" variant="outlined" label={DRIVER_STATUS[selected.driverStatus] || "Assigned"} />
              </Stack>

              {notice && <Alert severity={notice.severity}>{notice.text}</Alert>}

              <Paper elevation={2} sx={{ p: 2 }}>
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>1. Pick up from</Typography>
                <Typography>{selected.seller?.name}</Typography>
                {selected.seller?.phone && <Typography variant="body2">Phone: {selected.seller.phone}</Typography>}
                {selected.seller?.location && (
                  <MDBox mt={1}>
                    <iframe
                      title="Seller location"
                      width="100%"
                      height="200"
                      style={{ border: 0, borderRadius: 8 }}
                      loading="lazy"
                      allowFullScreen
                      src={`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${selected.seller.location.lat},${selected.seller.location.lng}&zoom=14`}
                    />
                  </MDBox>
                )}
                <Divider sx={{ my: 1.5 }} />
                {selected.items.map((item) => (
                  <Typography key={item.productId} variant="body2">
                    {item.quantity} × {item.title}
                  </Typography>
                ))}
              </Paper>

              <Paper elevation={2} sx={{ p: 2 }}>
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>2. Deliver to</Typography>
                <Typography>
                  {selected.order.recipient?.name || selected.order.shipping?.contactName || selected.order.buyer?.name || "Customer"}
                  {selected.order.recipient?.type === "business" ? " (business)" : selected.order.recipient?.type === "other" ? " (receiving for the buyer)" : ""}
                </Typography>
                {(selected.order.recipient?.phone || selected.order.shipping?.phone) && (
                  <Typography variant="body2">
                    WhatsApp / phone: {selected.order.recipient?.phone || selected.order.shipping.phone}{" "}
                    <a href={whatsappLink(selected.order.recipient?.phone || selected.order.shipping.phone)} target="_blank" rel="noopener noreferrer">
                      Message on WhatsApp
                    </a>
                  </Typography>
                )}
                <Typography variant="body2">{addressOf(selected.order.shipping) || "No address on the order"}</Typography>
                {selected.order.dropoff && (
                  <Typography variant="body2">
                    <a
                      href={`https://www.google.com/maps/dir/?api=1&destination=${selected.order.dropoff.lat},${selected.order.dropoff.lng}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Directions to the drop-off pin
                    </a>
                  </Typography>
                )}
                {selected.deliveryFeeCents > 0 && (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Vehicle: <b>{VEHICLE_LABEL[selected.vehicleType] || selected.vehicleType}</b>
                    {selected.distanceKm != null ? ` · about ${selected.distanceKm} km` : ""} · you earn{" "}
                    <b>${((selected.deliveryFeeFinalCents ?? selected.deliveryFeeCents) / 100).toFixed(2)}</b> when the code is confirmed
                    {selected.driverPaidAt ? " (paid)" : ""}
                  </Typography>
                )}
                {selected.order.deliveryNote && (
                  <Alert severity="info" sx={{ mt: 1.5 }}>
                    {selected.order.deliveryNote}
                  </Alert>
                )}
              </Paper>

              {selected.driverStatus === "accepted" && selected.status === "Shipped" && (
                <Paper elevation={2} sx={{ p: 2 }}>
                  <Typography variant="subtitle1" fontWeight={700} gutterBottom>3. Confirm delivery</Typography>
                  <Typography variant="body2" sx={{ mb: 1.5 }}>
                    Ask the recipient for the 6-digit code from their email and their official ID.{" "}
                    {selected.order.recipient?.type === "business" ? "Check the ID of the person receiving for" : "Check that the name on the ID matches"}{" "}
                    <b>{selected.order.recipient?.name || selected.order.shipping?.contactName || selected.order.buyer?.name || "the order"}</b>,
                    then take a clear photo of it. Do not hand over the package without both.
                  </Typography>
                  <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1.5 }}>
                    <Button variant="outlined" component="label" disabled={busy}>
                      {idPhoto ? "Retake ID photo" : "Take ID photo"}
                      <input hidden type="file" accept="image/*" capture="environment" onChange={pickIdPhoto} />
                    </Button>
                    {idPhotoUrl && <img src={idPhotoUrl} alt="Recipient's ID" style={{ height: 64, borderRadius: 6 }} />}
                  </Stack>
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                    <TextField
                      size="small"
                      label="Delivery code"
                      value={code}
                      onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
                      inputProps={{ inputMode: "numeric" }}
                    />
                    <Button variant="contained" color="success" disabled={busy || code.length !== 6 || !idPhoto} onClick={confirm}>
                      Confirm delivery
                    </Button>
                    <Button variant="text" disabled={busy} onClick={resend}>
                      Resend code
                    </Button>
                  </Stack>
                </Paper>
              )}
            </Stack>
          )}
        </DialogContent>
        {selected && (
          <DialogActions sx={{ px: 3, py: 2 }}>
            {selected.driverStatus === "assigned" && ACTIVE.includes(selected.status) && (
              <>
                <Button color="error" disabled={busy} onClick={() => respond(false)}>
                  Decline
                </Button>
                <Button variant="contained" disabled={busy} onClick={() => setAskLocation(true)}>
                  Accept job
                </Button>
              </>
            )}
            {selected.driverStatus === "accepted" && selected.status === "Processing" && (
              <Button variant="contained" disabled={busy} onClick={pickedUp}>
                I picked it up
              </Button>
            )}
            <Button onClick={() => setSelectedId(null)}>Close</Button>
          </DialogActions>
        )}
      </Dialog>

      <Dialog open={askLocation && Boolean(selected)} onClose={() => setAskLocation(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Before you accept</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>Can you easily locate the seller and the recipient addresses of this order?</Typography>
          <Typography variant="body2">If you answer No, this job goes to another driver.</Typography>
        </DialogContent>
        <DialogActions>
          <Button color="error" disabled={busy} onClick={() => answerLocation(false)}>
            No
          </Button>
          <Button variant="contained" sx={{ color: "#fff !important" }} disabled={busy} onClick={() => answerLocation(true)}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Tables;
